const notie = require('notie');
VueNotie = {};
VueNotie.install = (Vue, options) => {
	Vue.prototype.$notie = notie
}
module.exports = VueNotie;